import styled from "styled-components";

interface CardProps {
  padding?: string;
  boxShadow?: string;
}

export const Card = styled.div<CardProps>`
  background-color: var(--mode-bg-neutral-weakest);
  padding: ${({ padding }) => padding};
  box-shadow: ${({ boxShadow }) => boxShadow};
`;
